import { createMetorialManagementSDK } from '@metorial/management';
import { organizationsLoader } from './organization';
import { withAuth } from './user/auth/withAuth';

// export let managementSDK = createMetorialManagementSDK({
//   // @ts-ignore
//   apiHost: import.meta.env.VITE_PUBLIC_API_HOST
// });

let managementSDKByOrgId = new Map<string, ReturnType<typeof createMetorialManagementSDK>>();

export let withManagementSDK = <T>(
  i: { organizationId: string } | { instanceId: string } | { projectId: string },
  cb: (sdk: ReturnType<typeof createMetorialManagementSDK>) => Promise<T>
) =>
  withAuth(async () => {
    let orgs = await organizationsLoader.fetchAndReturn();

    let orgId: string;

    if ('organizationId' in i && i.organizationId) {
      orgId = i.organizationId;
    } else if ('instanceId' in i && i.instanceId) {
      let org = orgs.find(o =>
        o.projects.some(p => p.instances.some(is => is.id === i.instanceId))
      )!;
      orgId = org?.id;
    } else if ('projectId' in i && i.projectId) {
      let org = orgs.find(o => o.projects.some(p => p.id === i.projectId))!;
      orgId = org?.id;
    } else {
      throw new Error('Invalid input');
    }

    let sdk = managementSDKByOrgId.get(orgId);

    if (!sdk) {
      sdk = createMetorialManagementSDK({
        // @ts-ignore
        apiHost: import.meta.env.VITE_PUBLIC_API_HOST,
        organizationId: orgId,
        enableDebugLogging: true
      });

      managementSDKByOrgId.set(orgId, sdk);
    }

    return await cb(sdk);
  });

export let autoPaginate = async <T>(
  cb: (input: { cursor: string | undefined }) => Promise<{
    items: T[];
    pagination: {
      afterCursor: string | null;
    };
  }>
): Promise<T[]> => {
  let items: T[] = [];
  let cursor: string | undefined;

  do {
    let { items: newItems, pagination } = await cb({ cursor });
    items.push(...newItems);
    cursor = pagination.afterCursor ?? undefined;
  } while (cursor);

  return items;
};
